import React from 'react';
import { IconMoon, IconSun } from '@tabler/icons-react';

// Sun/moon button that flips between light and dark (state lives in App via useTheme)
function ThemeToggle({ theme, toggle, labels, className = 'theme-toggle' }) {
  const label = theme === 'dark' ? labels.themeToLight : labels.themeToDark;
  return (
    <button type="button" className={className} onClick={toggle} aria-label={label} title={label}>
      {theme === 'dark' ? <IconSun size={18} stroke={1.75} /> : <IconMoon size={18} stroke={1.75} />}
    </button>
  );
}

export default ThemeToggle;
